import { MatchedGuestProfiles } from '@mews-commander/guest-profile';
import { MergeMode } from './types';

export enum MatchAndMergeGainSightEvents {
    MatchAndMergeDisplayed = 'MatchAndMergeDisplayed',
    MatchAndMergeEmptyDisplayed = 'MatchAndMergeEmptyDisplayed',
    MatchAndMergeReviewLater = 'MatchAndMergeReviewLater',
    MatchAndMergeConfirmed = 'MatchAndMergeConfirmed',
    MatchAndMergeClosed = 'MatchAndMergeClosed',
    MatchAndMergeGuestSummaryPanelDisplayed = 'MatchAndMergeGuestSummaryPanelDisplayed',
    MatchAndMergeGuestSummaryPanelClosed = 'MatchAndMergeGuestSummaryPanelClosed',
    MatchAndMergeNavigatedToCustomerProfile = 'MatchAndMergeNavigatedToCustomerProfile',
    MatchAndMergeKeepSeparateProfiles = 'MatchAndMergeKeepSeparateProfiles',
}

export const getGainSightEventObject = (matchedGuestProfiles: MatchedGuestProfiles, mergeMode: MergeMode) => ({
    customerId: matchedGuestProfiles.profiles[0]?.id,
    otherCustomerId: matchedGuestProfiles.profiles[1]?.id,
    confidenceLevel: matchedGuestProfiles.confidence,
    matchingFields: matchedGuestProfiles.matchedFields,
    preSelectedFields: matchedGuestProfiles.preSelectedFields,
    mergeInfo: matchedGuestProfiles.mergeInfo,
    mergeMode,
});
